"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GroupMembersModal = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _modal = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/modal"));

var _SearchBox = _interopRequireDefault(require("@insided/deprecated-preact-components/search-box/SearchBox"));

var _GroupMemberItem = require("./GroupMemberItem");

var _GroupMembersWidget = require("./GroupMembersWidget");

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _service = require("./service");

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_CURRENT_PAGE = 1;
var DEFAULT_PAGE_SIZE = 25;

var GroupMembersModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GroupMembersModal, _Component);

  var _super = _createSuper(GroupMembersModal);

  function GroupMembersModal() {
    var _this;

    (0, _classCallCheck2.default)(this, GroupMembersModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadMoreRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "userId", (0, _insidedDataStorage.getInsidedData)('user').userid);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      searchValue: '',
      members: [],
      currentPage: DEFAULT_CURRENT_PAGE,
      isEndOfList: false,
      isLoading: false,
      isLoadingMore: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setLoadMoreObserve();

              _context.next = 3;
              return _this.loadMembers(DEFAULT_CURRENT_PAGE);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setLoadMoreObserve", function () {
      if (typeof window !== 'undefined' && 'IntersectionObserver' in window) {
        var lazyObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var loadMoreComponent = entry.target;

              if (loadMoreComponent.classList.contains('is-shown')) {
                _this.loadMoreMembers();
              }
            }
          });
        });
        lazyObserver.observe(_this.loadMoreRef);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchMembers", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(page, searchString) {
        var members, response, totalPages;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                members = _this.state.members;
                _context2.prev = 1;
                _context2.next = 4;
                return (0, _service.fetchMembers)({
                  groupId: _this.props.group.id,
                  page: page,
                  pageSize: DEFAULT_PAGE_SIZE,
                  searchString: searchString
                });

              case 4:
                response = _context2.sent;
                totalPages = Math.ceil(response.total / DEFAULT_PAGE_SIZE);

                _this.setState({
                  members: members.concat((0, _GroupMembersWidget.mapUsers)(response.members)),
                  currentPage: page,
                  isEndOfList: page === totalPages
                });

                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](1);

                _logger.logger.error(_context2.t0, {
                  component: 'GroupMembersModal',
                  action: 'fetchMembers'
                });

                _this.setState({
                  isEndOfList: true,
                  isLoading: false,
                  isLoadingMore: false
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 9]]);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadMembers", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(page, searchString) {
        var isLoading;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                isLoading = _this.state.isLoading;

                if (!isLoading) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                _this.setState({
                  isLoading: true
                });

                _context3.next = 6;
                return _this.fetchMembers(page, searchString);

              case 6:
                _this.setState({
                  isLoading: false
                });

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadMoreMembers", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var _this$state, isLoadingMore, isEndOfList, currentPage, searchValue;

      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$state = _this.state, isLoadingMore = _this$state.isLoadingMore, isEndOfList = _this$state.isEndOfList, currentPage = _this$state.currentPage, searchValue = _this$state.searchValue;

              if (!(isLoadingMore || isEndOfList)) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt("return");

            case 3:
              _this.setState({
                isLoadingMore: true
              });

              _context4.next = 6;
              return _this.fetchMembers(currentPage + 1, searchValue);

            case 6:
              _this.setState({
                isLoadingMore: false
              });

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSearchInput", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(e) {
        var value;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                value = e.target.value;

                _this.setState({
                  searchValue: value,
                  members: []
                });

                _publish.default.trackEvent('userevent', {
                  type: 'Group Searched for members in the destination user list'
                });

                _context5.next = 5;
                return _this.loadMembers(DEFAULT_CURRENT_PAGE, value);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x5) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSearch", (0, _debounce.default)( /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(e) {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this.onSearchInput(e);

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x6) {
        return _ref6.apply(this, arguments);
      };
    }(), 500));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearSearch", /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(e) {
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                e.stopPropagation();

                _this.setState({
                  searchValue: '',
                  members: []
                });

                _context7.next = 4;
                return _this.loadMembers(DEFAULT_CURRENT_PAGE);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x7) {
        return _ref7.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(GroupMembersModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var onClose = this.props.onClose;
      var _this$state2 = this.state,
          searchValue = _this$state2.searchValue,
          members = _this$state2.members,
          isEndOfList = _this$state2.isEndOfList,
          isLoading = _this$state2.isLoading;
      return (0, _preact.h)(_modal.default, {
        onClose: onClose,
        customClass: "group-members-modal"
      }, (0, _preact.h)(_modal.ModalHeader, {
        title: (0, _preact.h)(_phrase.default, {
          p: "groups.members"
        })
      }), (0, _preact.h)(_modal.ModalBody, null, (0, _preact.h)("div", {
        className: "members-modal"
      }, (0, _preact.h)(_SearchBox.default, {
        isModerationOverview: true,
        placeholder: "Search for members...",
        value: searchValue,
        onSubmit: function onSubmit() {},
        onInput: this.handleSearch,
        onClear: this.onClearSearch,
        iconSize: 24,
        "data-bounded-context": "Groups",
        "data-entity": "group-members",
        "data-track-type": "click",
        "data-element-name": "Group Clicked the search member list on the group overview"
      }), (0, _preact.h)("div", {
        className: "members-modal_members"
      }, isLoading && !members.length ? (0, _preact.h)(_GroupMemberItem.GroupMembersListSkeleton, null) : null, !isLoading && members.length ? members.map(function (member) {
        return (0, _preact.h)(_GroupMemberItem.GroupMember, {
          key: member.id,
          member: member,
          disablePopup: true,
          isWidget: true,
          currentUserId: _this2.userId
        });
      }) : null, (0, _preact.h)(_GroupMemberItem.GroupMemberSkeleton, {
        isShown: !isEndOfList && !!(members !== null && members !== void 0 && members.length),
        setRef: function setRef(node) {
          _this2.loadMoreRef = node;
        }
      })))));
    }
  }]);
  return GroupMembersModal;
}(_preact.Component);

exports.GroupMembersModal = GroupMembersModal;
var _default = GroupMembersModal;
exports.default = _default;